/**
 * Parse an academy-local wall datetime (no offset) to epoch ms in that IANA zone.
 * Example: "2026-09-30T15:23:07" + America/New_York → correct absolute instant.
 */
export function academyWallTimeToMs(isoLocal, timeZone) {
  if (!isoLocal) return NaN;
  const m = String(isoLocal).trim().match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?)?/,
  );
  if (!m) return NaN;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const h = Number(m[4] || 0);
  const mi = Number(m[5] || 0);
  const s = Number(m[6] || 0);
  const tz = timeZone || 'UTC';

  // Iteratively correct UTC guess so the wall clock in `tz` matches.
  let utc = Date.UTC(y, mo - 1, d, h, mi, s);
  for (let i = 0; i < 3; i++) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(new Date(utc));
    const get = (type) => Number(parts.find((p) => p.type === type)?.value);
    let hour = get('hour');
    if (hour === 24) hour = 0; // rare Intl quirk
    const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), hour, get('minute'), get('second'));
    const target = Date.UTC(y, mo - 1, d, h, mi, s);
    utc += target - asUtc;
  }
  return utc;
}
